export const CALCULATION_COMMENTS = {
    'CALCULATION.COMMENTS.MODAL.TITLE': 'Comentarii',
    'CALCULATION.COMMENTS.PLACEHOLDER': 'Introduceți comentariul (max 500 caractere)',
    'CALCULATION.COMMENTS.FEATURE_DISABLED': 'Nu aveți dreptul să adăugați comentarii, pentru a activa această opțiune contactați Administratorul KPMG'
};
